import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import DropDownInput from "../DropDownInput/DropDownInput";
import SearchOptions from "components/SearchFilters/searchOptions/searchOptions";
import LoadingBox from "components/loadingBox/loadingBox";
import { FilterContext } from "contextos/FilterContext";
import FiltersForm from "modules/website/components/FiltersForm/FiltersForm";
import styles from "./SearchFilters.module.scss";

const SearchFilters = () => {
  const [actualColection, setColection] = useState({});
  const [loaded, setLoad] = useState(false);
  const [colections, setFilters] = useState({ data: [], loading: true });
  const [search] = useSearchParams();
  const { filters, cleanner } = useContext(FilterContext);
  const catchCollection = (value) => {
    // setSearchParams({});
    if (value) {
      setColection(colections.data.find((col) => col.value === value));
    } else {
      setColection(colections.data.find((col) => col?.isDefault));
    }
  };
  useEffect(() => {
    console.log(filters);
    if(filters.length > 0){
      setFilters({ data: filters, loading: false });
    }
  }, [filters]);
  // PARA LOS PARAMS AL INGRESAR A AL SITIO
  useEffect(() => {
    //setLoad(true);
    /* let repository = search.get("repository");
    if (repository) {
      setColection(colections.data.find((col) => col.value === repository));
    } */
    if(colections.data.length > 0){
      console.log(colections.data);
      setColection(colections.data.find((col) => col?.isDefault));
    }
    //setColection(colections.data.find((col) => col?.isDefault));
    //setColection(filters[0]);
  }, [colections, search]);

  useEffect(() => {
    if (Object.keys(actualColection).length > 0) {
      setLoad(true);
    }
  }, [actualColection]);
  const renderOptios = () => {
    /* if (actualColection) { */
    return (
      <div>
        <SearchOptions colection={actualColection} loaded={loaded} />
        <div className="row">
          {actualColection?.sortby && (
            <div className="col-12 form-group">
              <hr />
              <label htmlFor="sortby" className={`${styles.title}`}>Order:</label>
              <DropDownInput
                name="sortby"
                options={actualColection?.sortby}
              />
            </div>
          )}
          {
            actualColection?.respp && (
              <div className="col-12 form-group">
                <label htmlFor="respp" className={`${styles.title}`}>Quantity:</label>
                <DropDownInput
                  name="respp"
                  options={actualColection?.respp}
                />
              </div>
            )}
        </div>
      </div>
    );
    /* } */
  };

  return (
    <React.Fragment>
      {loaded && !colections.loading ? (
        <React.Fragment style={{ backgroundColor: '#f5f5f5' }}>
          {/* <div className="row">
            <div className="col-12 form-group">
              <label htmlFor="repository">Acervos:</label>
              <DropDownInput
                name="repository"
                options={colections.data}
                cambio={catchCollection}
                actualColection={actualColection}
              />
            </div>
          </div> */}
          {renderOptios()}
          {/* <FiltersForm /> */}
          {/* BOTON FILROS */}
          <div className="row mt-1">
            {/* <div className="col-12">
              <hr />
              <button className="btn btn-primary col-12">
                Aplicar filtros
              </button>
            </div> */}
            <div className="col-12 mt-2">
              <div
                id="cleanFilters"
                className={`btn col-12 mb-3 ${styles.cleanFilters}`}
                onClick={() => {
                  catchCollection();
                  cleanner();
                }}
              >
                Clear filters
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <LoadingBox />
      )}
    </React.Fragment>
  );
};

export default SearchFilters;
